export default __webpack_public_path__ + "static/media/star-blue-icon.9543d65f.svg";